import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Trash2, Users } from 'lucide-react';
import { toast } from 'sonner';

export default function TemplatesPage() {
  const [items, setItems] = useState([]);
  const load = () => api.get('/b2b/templates').then(r => setItems(r.data.items || []));
  useEffect(() => { load(); }, []);
  const del = async (id) => { await api.delete(`/b2b/templates/${id}`); toast.success('Deleted'); load(); };
  return (
    <div className="space-y-4">
      <h1 className="font-serif text-3xl text-[hsl(var(--brand-navy-2))]">Templates</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map(t => (
          <Card key={t.id} className="bg-white"><CardContent className="p-5">
            <div className="flex items-center gap-2 mb-3"><Users className="h-5 w-5 text-[hsl(var(--brand-navy))]" /><div className="font-serif text-lg">{t.name}</div></div>
            <div className="text-sm text-[hsl(var(--muted-foreground))]">{t.recipients.length} recipients</div>
            <div className="mt-4 flex justify-end"><Button size="sm" variant="destructive" onClick={() => del(t.id)}><Trash2 className="h-4 w-4" /></Button></div>
          </CardContent></Card>
        ))}
      </div>
      {items.length === 0 && <Card className="bg-white"><CardContent className="p-8 text-center text-sm text-[hsl(var(--muted-foreground))]">No templates yet. Save one from the Mass payments page.</CardContent></Card>}
    </div>
  );
}
